import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import DOMPurify from "dompurify";

function NewsDetails() {
  const baseUrl =
    "https://isbmuniversity.edu.in/admin-portal/admin-assets/news-banners/";
  const { newsId } = useParams();

  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchNewsDetails = async () => {
      try {
        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/news/${newsId}`
        );
        const newsData = response.data?.data?.[0] || null;
        setNews(newsData);
      } catch (err) {
        console.error("Error fetching news:", err);
        setError("Failed to load news details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchNewsDetails();
  }, [newsId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-danger">{error}</div>;
  if (!news) return <div>No news found.</div>;

  // Utility: check if content is an image URL
  const isImageUrl = (value) => {
    if (!value) return false;
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(value.trim());
  };

  return (
    <>
      <Topnav />
      <div className="blog-single gray-bg">
        <div className="container">
          <article className="article">
            {/* Banner Image */}
            {news.banner && (
              <div className="article-img">
                <img
                  src={baseUrl + news.banner}
                  title={news.title}
                  alt={news.title}
                  className="img-fluid"
                />
              </div>
            )}

            {/* Title */}
            <div className="article-title">
              <h6>
                <span>News</span>
              </h6>
              <h1>{news.title}</h1>
            </div>

            {/* Content */}
            <div className="article-content">
              {isImageUrl(news.content) ? (
                <img
                  src={news.content}
                  alt={news.title}
                  title={news.title}
                  className="img-fluid w-100"
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(news.content || "", {
                      FORBID_ATTR: [
                        "data-sheets-value",
                        "data-sheets-userformat",
                      ],
                      FORBID_TAGS: ["o:p"], // keep span/font if needed
                    }),
                  }}
                />
              )}
            </div>
          </article>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NewsDetails;
